"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolConfig = exports.PoolConfigData = void 0;
const program_1 = require("../program");
const buffer_1 = require("buffer");
const common_1 = require("@everlend/common");
class PoolConfigData extends common_1.Borsh.Data {
}
exports.PoolConfigData = PoolConfigData;
_a = PoolConfigData;
PoolConfigData.SCHEMA = _a.struct([
    ['accountType', 'u8'],
    ['deposit_minimum', 'u64'],
    ['withdraw_minimum', 'u64'],
]);
class PoolConfig extends common_1.Account {
    constructor(key, info) {
        super(key, info);
        if (!this.assertOwner(program_1.GeneralPoolsProgram.PUBKEY)) {
            throw common_1.Errors.ERROR_INVALID_OWNER();
        }
        this.data = PoolConfigData.deserialize(this.info.data);
    }
    static getPDA(pool) {
        return program_1.GeneralPoolsProgram.findProgramAddress([buffer_1.Buffer.from('config'), pool.toBuffer()]);
    }
    static findMany(connection, pools) {
        return __awaiter(this, void 0, void 0, function* () {
            const poolConfigs = [];
            for (const pool of pools) {
                const poolConfig = yield PoolConfig.getPDA(pool);
                poolConfigs.push(poolConfig);
            }
            const poolConfigAccounts = yield connection.getMultipleAccountsInfo(poolConfigs);
            return poolConfigAccounts
                .map((account, idx) => {
                if (account == null) {
                    return;
                }
                try {
                    return Object.assign(Object.assign({}, new PoolConfig(poolConfigs[idx], account)), { poolPubKey: pools[idx] });
                }
                catch (err) {
                    console.error(new Error(`cannot deserialize pool config for ${pools[idx].toString()}`));
                }
            })
                .filter(Boolean);
        });
    }
}
exports.PoolConfig = PoolConfig;
PoolConfig.LEN = 17;
//# sourceMappingURL=poolConfig.js.map